var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPodcastSmall = function SvgPodcastSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.987 1a1.91 1.91 0 0 0-1.909 1.91V8a1.91 1.91 0 0 0 3.818 0V2.91A1.91 1.91 0 0 0 7.987 1M3.531 8.001V8h1.272V8a3.182 3.182 0 0 0 6.363 0h1.274V8c0 2.245-1.659 4.101-3.818 4.41v1.316h1.91v1.272h-5.09v-1.272H7.35V12.41A4.456 4.456 0 0 1 3.53 8m.002-1.911h1.273v1.909H3.533zm8.908 0h-1.273v1.909h1.273z",
    clipRule: "evenodd"
  })));
};
export default SvgPodcastSmall;